import { pushDataLayerEvent, type SignUpStartTrigger } from './dataLayer'

// Set by the code that opens the auth modal for a special reason (a referral
// link), consumed once by the modal when it opens.
let pendingTrigger: SignUpStartTrigger | null = null

export function markSignUpStartTrigger(trigger: SignUpStartTrigger): void {
  pendingTrigger = trigger
}

/** The modal opened on sign-up, or the user switched to it from login. */
export function pushSignUpStart(trigger?: SignUpStartTrigger): void {
  pushDataLayerEvent({
    event: 'sign_up_start',
    signup_flow: 'modal',
    trigger: trigger ?? pendingTrigger ?? 'open'
  })
  pendingTrigger = null
}
